export interface PossibleTypesResultData {
  possibleTypes: {
    [key: string]: string[]
  }
}
const result: PossibleTypesResultData = {
  possibleTypes: {
    IndexedDocument: ['IndexedProduct'],
    Node: ['EScript', 'Invoice', 'Order', 'RewardsOrder', 'RewardsSnapshot', 'RewardsTransaction'],
    OrderLine: ['OrderLineItem', 'OrderLineItemGroup'],
    PayoutMethod: ['PayoutMethodAch'],
    SearchResultItem: ['BlogPost', 'LibraryResource', 'Page', 'ParentProduct', 'Product'],
  },
}
export default result
